import { MedicalSummarySection } from '../../../../components';
import { handleEnterKeyPress } from "../../../../utils/handleEnterKey";
import FileUploadErrorModal from '../../../../utils/fileUploadErrorModal';
import MedicalProviderSec from '../../../../components/ui-control/MedicalProviderSec';
import ReorderMedicalProvider from '../../../../components/ui-control/ReorderMedicalProvider';
import AccordionItem from '../../../../components/common/accordionItem';
import Constants from '../../../../Constants';
import { useAddCaseFormContext } from '../../../../contexts/AddCaseFormContext';
import { formBackgroundClasses, formItemPdClasses } from '../../../../components/common/formClasses';
import { TOUR_TARGETS } from '../../../../constants/tourTargets';

const MedicalProviderForm = () => {

    const { fileErrorList, setFileErrorList, isShowReorderSec } = useAddCaseFormContext();

    return (
        <>
            <form onKeyDown={(e) => handleEnterKeyPress(e)}>
                {Constants.MedicalProviderSections.map(section => (
                    <ReorderMedicalProvider
                        key={section.providerType}
                        heading={section.reorderHeading}
                        providerType={section.providerType}
                    />
                ))}

                {!isShowReorderSec.preAccident && !isShowReorderSec.postAccident && <div className={`${formBackgroundClasses} ${formItemPdClasses}`}>
                    <div data-tour={TOUR_TARGETS.MEDICAL_PROVIDERS_POST}>
                        <MedicalProviderSec
                            providerType="postAccident"
                            heading="Post-Incident Medical Records"
                        />
                    </div>

                    <div data-tour={TOUR_TARGETS.MEDICAL_PROVIDERS_PRIOR}>
                        <AccordionItem title="Prior Medical Records" defaultOpen={false} noBorder noPaddingLeft titleClassName="text-2xl" className="mt-3">
                            <MedicalProviderSec
                                providerType="preAccident"
                                heading=""
                            />
                        </AccordionItem>
                    </div>

                    <div data-tour={TOUR_TARGETS.MEDICAL_SUMMARY}>
                        <MedicalSummarySection />
                    </div>
                </div>}
            </form>
            <FileUploadErrorModal fileErrorList={fileErrorList} setFileErrorList={setFileErrorList} />
        </>
    )
}

export default MedicalProviderForm;